import { render, staticRenderFns } from "./AdjustmentList.vue?vue&type=template&id=5fc497ff&"
import script from "./AdjustmentList.vue?vue&type=script&lang=js&"
export * from "./AdjustmentList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports